export enum PaymentMethod {
    ItauNacaoTed = 1,
    ItauNacaoBoleto = 2,
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/PaymentMethod.ts